import { Metamodel } from '../base/model';
import { Owned } from '../base/named';
import { IAttribute, IModel } from '../base/annotation';

@Metamodel.model({})
export class StoreSettingPartitionKey extends Owned {
    public static readonly MODEL: IModel;
    public static readonly PARTITITON_KEY: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        accepts: ['String'],
        association: 'PARTITITON_KEY'
    })
    public partitionKey: string;

    public static createDefaultPartitionKeyOption(defaultColumnName: string = '', owner:  Owned): StoreSettingPartitionKey {
        const result = Owned.create<StoreSettingPartitionKey>(StoreSettingPartitionKey.MODEL, owner);
        result.partitionKey = defaultColumnName;
        return result;
    }
}
